// audio files
import LastNightLive from '../_audio/LastNightLive.mp3';
import BlackMagic from '../_audio/BlackMagicWoman.mp3';
import HotelCali from '../_audio/HotelCali.mp3';

// audio thumbnails
import understanding from '../_thumbnails/spencer-and-aiden.webp';
import guitar from '../_thumbnails/Guitar.webp';
import matt from '../_thumbnails/Matt.webp';

export const tracks = [
    {
        id: 0,
        title: 'Where Did You Sleep Last Night',
        src: LastNightLive,
        date: 'December 6 2024',
        thumbnail: understanding,
    },
    {
        id: 1,
        title: 'Black Magic Woman',
        src: BlackMagic,
        date: 'December 6 2024',
        thumbnail: guitar,
    },
    {
        id: 2,
        title: 'Hotel California',
        src: HotelCali,
        date: 'December 6 2024',
        thumbnail: matt,
    },
];